import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { fromEvent, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-partner-navigation-sidebar",
  templateUrl: "./partner-navigation-sidebar.component.html",
  styleUrls: ["./partner-navigation-sidebar.component.scss"]
})
export class PartnerNavigationSidebarComponent implements OnInit, OnDestroy {
  @Input() sections: { id: string; label: string }[] = [];
  @Input() scrollContainerSelector = ".mat-drawer-content";
  @Input() headerOffset = 160;
  @Input() scrollSpyOffset = 180;

  activeSectionId = "";
  private isScrolling = false;
  private destroy$ = new Subject<void>();

  get activeIndex(): number {
    return this.sections.findIndex(s => s.id === this.activeSectionId);
  }

  ngOnInit(): void {
    if (this.sections.length > 0) {
      this.activeSectionId = this.sections[0].id;
    }
    this.setupScrollSpy();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  scrollTo(sectionId: string): void {
    const element = document.getElementById(sectionId);
    const container = document.querySelector(this.scrollContainerSelector);

    if (element && container) {
      this.isScrolling = true;
      this.activeSectionId = sectionId;

      const elementPosition = element.getBoundingClientRect().top - container.getBoundingClientRect().top;
      const offsetPosition = elementPosition + container.scrollTop - this.headerOffset;

      container.scrollTo({ top: offsetPosition, behavior: "smooth" });

      setTimeout(() => (this.isScrolling = false), 1000);
    }
  }

  private setupScrollSpy(): void {
    const container = document.querySelector(this.scrollContainerSelector);
    if (container) {
      fromEvent(container, "scroll")
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          if (!this.isScrolling) {
            this.onScroll(container);
          }
        });
    }
  }

  private onScroll(container: Element): void {
    let currentSectionId = this.sections[0]?.id || "";

    for (const section of this.sections) {
      const element = document.getElementById(section.id);
      if (element) {
        const rect = element.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const top = rect.top - containerRect.top;

        if (top <= this.scrollSpyOffset) {
          currentSectionId = section.id;
        } else {
          break;
        }
      }
    }

    this.activeSectionId = currentSectionId;
  }
}
